
jQuery(function makeTravelDatePicker($) {

	$('.add-travel-dates').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-travel-dates');

		// Start date
		var $newStartDate = $('#start-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'yyyy-mm-dd',
			formatSubmit: 'yyyy-mm-dd'
		});
		var newStartDatePicker = $newStartDate.pickadate('picker');

		// End date
		var $newEndDate = $('#end-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'yyyy-mm-dd',
			formatSubmit: 'yyyy-mm-dd'
		});
		var newEndDatePicker = $newEndDate.pickadate('picker');

	});
});
